/**
 * ATTENTION! This file is auto-generated for the 'identity' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { UserRepository } from '../server/repositories/UserRepository';
import type { RoleRepository } from '../server/repositories/RoleRepository';
import type { RbacActionRepository } from '../server/repositories/RbacActionRepository';
import type { RbacRepositoryRepository } from '../server/repositories/RbacRepositoryRepository';
import type { AccessTokenLogRepository } from '../server/repositories/AccessTokenLogRepository';
import type { RefreshTokenRepository } from '../server/repositories/RefreshTokenRepository';
import type { GroupTypeRepository } from '../server/repositories/GroupTypeRepository';
import type { GroupRepository } from '../server/repositories/GroupRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type UserRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<UserRepository>;
export function useUserRepository(): UserRepositoryClient { return makeRepositoryProxy<UserRepositoryClient>('identity::UserRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useUserRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const userRepository = useUserRepository();

type RoleRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RoleRepository>;
export function useRoleRepository(): RoleRepositoryClient { return makeRepositoryProxy<RoleRepositoryClient>('identity::RoleRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRoleRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const roleRepository = useRoleRepository();

type RbacActionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RbacActionRepository>;
export function useRbacActionRepository(): RbacActionRepositoryClient { return makeRepositoryProxy<RbacActionRepositoryClient>('identity::RbacActionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRbacActionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rbacActionRepository = useRbacActionRepository();

type RbacRepositoryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RbacRepositoryRepository>;
export function useRbacRepositoryRepository(): RbacRepositoryRepositoryClient { return makeRepositoryProxy<RbacRepositoryRepositoryClient>('identity::RbacRepositoryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRbacRepositoryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rbacRepositoryRepository = useRbacRepositoryRepository();

type AccessTokenLogRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AccessTokenLogRepository>;
export function useAccessTokenLogRepository(): AccessTokenLogRepositoryClient { return makeRepositoryProxy<AccessTokenLogRepositoryClient>('identity::AccessTokenLogRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAccessTokenLogRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const accessTokenLogRepository = useAccessTokenLogRepository();

type RefreshTokenRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RefreshTokenRepository>;
export function useRefreshTokenRepository(): RefreshTokenRepositoryClient { return makeRepositoryProxy<RefreshTokenRepositoryClient>('identity::RefreshTokenRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRefreshTokenRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const refreshTokenRepository = useRefreshTokenRepository();

type GroupTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<GroupTypeRepository>;
export function useGroupTypeRepository(): GroupTypeRepositoryClient { return makeRepositoryProxy<GroupTypeRepositoryClient>('identity::GroupTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useGroupTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const groupTypeRepository = useGroupTypeRepository();

type GroupRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<GroupRepository>;
export function useGroupRepository(): GroupRepositoryClient { return makeRepositoryProxy<GroupRepositoryClient>('identity::GroupRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useGroupRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const groupRepository = useGroupRepository();

type getCurrentUserType = typeof import('../server/functions/getCurrentUser').getCurrentUser;
export const getCurrentUser: RpcFunctionClient<getCurrentUserType> = makeFunctionProxy<getCurrentUserType>('identity::getCurrentUser');

type loginType = typeof import('../server/functions/login').login;
export const login: RpcFunctionClient<loginType> = makeFunctionProxy<loginType>('identity::login');

type logoutType = typeof import('../server/functions/logout').logout;
export const logout: RpcFunctionClient<logoutType> = makeFunctionProxy<logoutType>('identity::logout');

type registerType = typeof import('../server/functions/register').register;
export const register: RpcFunctionClient<registerType> = makeFunctionProxy<registerType>('identity::register');

type changePasswordType = typeof import('../server/functions/changePassword').changePassword;
export const changePassword: RpcFunctionClient<changePasswordType> = makeFunctionProxy<changePasswordType>('identity::changePassword');

type hasPermissionType = typeof import('../server/functions/hasPermission').hasPermission;
export const hasPermission: RpcFunctionClient<hasPermissionType> = makeFunctionProxy<hasPermissionType>('identity::hasPermission');

type grantAllPermissionsType = typeof import('../server/functions/grantAllPermissions').grantAllPermissions;
export const grantAllPermissions: RpcFunctionClient<grantAllPermissionsType> = makeFunctionProxy<grantAllPermissionsType>('identity::grantAllPermissions');

type revokeAllPermissionsType = typeof import('../server/functions/revokeAllPermissions').revokeAllPermissions;
export const revokeAllPermissions: RpcFunctionClient<revokeAllPermissionsType> = makeFunctionProxy<revokeAllPermissionsType>('identity::revokeAllPermissions');

type generateApiTokenType = typeof import('../server/functions/generateApiToken').generateApiToken;
export const generateApiToken: RpcFunctionClient<generateApiTokenType> = makeFunctionProxy<generateApiTokenType>('identity::generateApiToken');

type generateApiTokenForUserType = typeof import('../server/functions/generateApiTokenForUser').generateApiTokenForUser;
export const generateApiTokenForUser: RpcFunctionClient<generateApiTokenForUserType> = makeFunctionProxy<generateApiTokenForUserType>('identity::generateApiTokenForUser');
